module.exports = __webpack_public_path__ + "ecfcb0264b4f2ca8f12080e56cfba8b0.pdf";